// extracted by mini-css-extract-plugin
export default {"checked":"BtnIsChecked_checked__NyGmW","unchecked":"BtnIsChecked_unchecked__4YPv3"};